import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

import WsContextMenu, { ContextMenuItemProps } from './WsContextMenu';
export interface ContextMenuHandlerProps {
  top: number;
  left: number;
  menuItems: ContextMenuItemProps[];
  setContextMenuDetails: Dispatch<
    SetStateAction<{
      showContext: boolean;
      x: number;
      y: number;
    }>
  >;
}
const WsContextMenuHandler = ({
  top,
  left,
  menuItems,
  setContextMenuDetails,
}: ContextMenuHandlerProps) => {
  const defaultContextMenuValues = { showContext: false, x: 0, y: 0 };
  const handleMenuItemClick = (action) => {
    action();
    setContextMenuDetails(defaultContextMenuValues);
  };
  const contextMenuRef = useRef(null);
  const handleClickOutside = (event) => {
    if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
      setContextMenuDetails(defaultContextMenuValues);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <WsContextMenu
      top={top}
      left={left}
      menuItems={menuItems}
      onMenuItemClick={handleMenuItemClick}
      ref={contextMenuRef}
    />
  );
};
export default WsContextMenuHandler;
